// extracted by mini-css-extract-plugin
export default {"component":"mWgM1d","mobile":"ZKZ0M4"};